import { useState } from "react";
import { getBancos, getSubsidioMutuo } from "../services/serviceSubsidios";
import { selectorTransversal } from "../../../dtos/selector";
import { AxiosResponse } from "axios";
import { ListResponseDto } from "../../../dtos/ListResponseDto";

export interface SubsidioMutuo {
    id?: number,
    mutuoId?: number,
    codProyecto?: string | null,
    resolucion?: string | null,
    libreta?: string | null,
    serie?: string | null,
    bonoIntegracion?: number | null,
    bonoCaptacion?: number | null,
    ahorro?: number | null,
    codigoBanco?: string | null,
    subsidio?: number | null
}

export interface Banco {
    codigo: string,
    descripcion: string
}

export function useSubsidioMutuo(mutuoId: number) {

    const [subsidioMutuo, setSubsidioMutuo] = useState<SubsidioMutuo>({

        id: 0,
        mutuoId: mutuoId,
        ahorro: 0,
        bonoCaptacion: 0,
        bonoIntegracion: 0,
        codigoBanco: '',
        codProyecto: '',
        libreta: '',
        resolucion: '',
        serie: '',
        subsidio: 0

    });

    const [selectorBancos, setSelectorBancos] = useState<selectorTransversal[]>([]);

    const buscarSubsidioMutuo = async (mutuoId: number) => {

        const resp = await getSubsidioMutuo(mutuoId);

        if (resp && resp.status === 200) {

            const datosSubsidio: SubsidioMutuo = await resp.data;
            setSubsidioMutuo(datosSubsidio);

        }

    }

    const obtenerBancos = async () => {

        const resp: AxiosResponse<ListResponseDto<Banco>> = await getBancos();

        if (resp && resp.status === 200) {

            const bancos: Banco[] = await resp.data.items;

            let selectorBancos: selectorTransversal[] = [];
            bancos.map((x) => selectorBancos.push({ value: (x.codigo), label: x.descripcion }));

            setSelectorBancos(selectorBancos);
        }
    }

    return { buscarSubsidioMutuo, subsidioMutuo, obtenerBancos, selectorBancos }
} 